<template>
  <div>
    <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }" v-if="!lumbredocs_v3">
      <b-row no-gutters>
        <b-col class="col-left hv-100" v-bind:style="{ background: loginBgColor, textAlign: loginTextAlign  }">
          <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
            <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite"/>
          </router-link>
          <div v-if="authMode === 'session'">
            <h4 class="mt-4">{{ $t('password_restore_title')}}</h4>
            <div v-if="restoredPasswordSuccessfully" class="mt-3">
              <p>
                {{ $t('password_updated_successfully_msg')}}
              </p>
            </div>
            <div v-else>
              <LmComponentLoading v-if="loading"/>
              <LmPassword
                @enter="saveNewPassword"
                v-model="form.newPassword"
                :v="$v.form.newPassword"
                :serverErrorMessage="serverErrorMessage"
                :label="$t('password')"
                />
              <LmPassword
              @enter="saveNewPassword"
              v-model="form.newPasswordAgain"
              :v="$v.form.newPasswordAgain"
              :serverErrorMessage="serverErrorMessage"
              :label="$t('password_again')"
              />
              <button
                autofocus
                id="session-is-authenticated-else"
                class="btn btn-primary btn-margin mt-3 buttonLogin"
                @click="saveNewPassword"
              >
                <i class="mdi mdi-login"></i>
                {{ $t('restore_password_button_msg')}}
              </button>
            </div>
          </div>
        </b-col>
        <b-col class="col-right hv-100 d-none d-xl-block">
          <div class="auth-user-testimonial">
            <h2 class="mb-3">{{ title1 }}</h2>
            <p class="lead">
              <i class="mdi mdi-format-quote-open"></i>
              {{ text }}
              <i class="mdi mdi-format-quote-close"></i>
            </p>
            <p>{{ title2 }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="login-wrapper" v-else>
      <b-row no-gutters class="h-100">
        <b-col md="4" cols="12">
          <form class="login-form" @submit.prevent="saveNewPassword">
            <div class="d-flex flex-column justify-content-center h-100">
              <div class="mb-5 login-logo">
                <img :src="logoHomeImg" alt="Logo" />
                <h4 class="text-right">Rápido, seguro y digital</h4>
              </div>
              <label class="lm-input-label">
                {{ $t('password') }}
                <input
                  type="password"
                  placeholder="****"
                  class="lm-input"
                  :class="{ 'error': $v.form.newPassword.$error }"
                  v-model.lazy="$v.form.newPassword.$model"
                >
                <small class="lm-input-caption" v-if="$v.form.newPassword.$error">Campo inválido</small>
              </label>
              <label class="lm-input-label">
                {{ $t('password_again') }}
                <input
                  type="password"
                  placeholder="****"
                  class="lm-input"
                  :class="{ 'error': $v.form.newPasswordAgain.$error }"
                  v-model.lazy="$v.form.newPasswordAgain.$model"
                >
                <small class="lm-input-caption" v-if="$v.form.newPasswordAgain.$error">Campo inválido</small>
              </label>
              <button type="submit" class="lm-button" :disabled="loading">
                <template v-if="!loading">
                  Guardar
                </template>
                <template v-else>
                  <i class="mdi mdi-loading lm-button-loading"></i>
                </template>
              </button>
              <img :src="logoLumileWhite" alt="Logo" width="80" class="mt-5">
            </div>
          </form>
        </b-col>
        <b-col md="8" class="d-none d-md-block">
          <section
            class="login-background"
          >
            <h1 class="login-title">¡Comenzá la transformación digital de tu empresa!</h1>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  name: 'app',
  inject: ['lumbredocs_v3'],
  components: {
    LmTextInput,
    LmPassword
  },
  mixins: [lmToasts],
  data () {
    return {
      form: {
        newPassword: '',
        newPasswordAgain: ''
      },
      serverErrorMessage: '',
      loading: false,
      restoredPasswordSuccessfully: false
    }
  },
  validations: {
    form: {
      newPassword: {
        required
      },
      newPasswordAgain: {
        sameAsNewPassword: sameAs('newPassword')
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getNotifications']),
    async saveNewPassword () {
      this.$v.$touch()
      if (!this.$v.form.$invalid) {
        this.loading = true
        try {
          await commonsApi.axiosPutWrapper(
            process.env?.VUE_APP_RESTORE_PASSWORD_URL + this.$route.query.token,
            {
              new_password: this.form.newPassword,
              new_password_again: this.form.newPasswordAgain
            }
          )
          this.restoredPasswordSuccessfully = true
          this.lmToastSuccessMessage('Se guardó la nueva contraseña.', 'Guardado con éxito')
          setTimeout(() => {
            this.$router.push('/login')
          }, 3000)
        } catch (err) {
          this.lmToastDangerMessage(err.response.data.message, `${err.response.data.type} - ${err.response.data.code}`)
        } finally {
          this.loading = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign', 'logoLumileWhite']),
    authMode () {
      return process.env.VUE_APP_AUTH_MODE
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.replace('/')
    }
  },
  mounted () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
.login-wrapper
  padding: 0
  height: 100vh

@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.login-logo
  width: 90%

.login-form
  color: white
  padding: 0 20%
  height: 100%
  background: rgb(255,21,99)
  background: linear-gradient(90deg, rgba(255,21,99,1) 0%, rgba(176,58,135,1) 100%)

  .lm-button
    text-transform: uppercase
    background-color: white
    color: black
    border-radius: 20px
    border: none
    padding: 8px 20px
    margin-top: 40px
    font-weight: bold
    transition: all .4s ease-in-out
    &:disabled
      cursor: not-allowed
      background-color: rgba(232, 232, 232, .9)
    &:hover
      transform: scale(1.02)
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
    .lm-button-loading::before
      font-weight: bold
      animation-name: spin
      animation-duration: 1000ms
      animation-iteration-count: infinite
      animation-timing-function: linear
  .lm-link
    display: inline
    background: transparent
    color: white
    border: none
    border-bottom: 1px solid rgba(255, 255, 255, .4)
  .lm-input-label
    font-weight: bold
    display: flex
    flex-direction: column
  .lm-input
    font-weight: bold
    margin-top: 8px
    height: 42px
    border: none
    border-radius: 20px
    padding: 0 20px
    color: black
    background-color: rgba(241, 241, 241, .5)
    transition: all .4s ease-in-out
    &:focus
      outline: none
      box-shadow: 0 0 0 0.25rem rgba(58, 66, 165, .4)
    &::placeholder
      color: #4F4F4F
    &.error
      box-shadow: 0 0 0 0.25rem rgba(197, 0, 0, .4)
  .lm-input-caption
    letter-spacing: .075rem
    font-size: .7rem
    padding: 6px 20px
    color: white

.login-background
  height: 100%
  background-color: white
  background-repeat: no-repeat
  background-attachment: fixed
  background-position: center
  background-size: 80%
  position: relative

.login-title
  width: 50%
  color: #3B43A6
  font-size: 2.6rem
  position: absolute
  top: 15%
  left: 5%

#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 48px 55px
    max-width: 480px
    width: 100%
    @media(max-width: $xl)
      max-width: none
      padding: 72px 56px
    .logoSite
      @media(max-width: $xl)
        margin: 0 auto
        display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
    .buttonLogin
      box-shadow: 0 2px 6px 0 rgba(114,124,245,.5)
      width: 100%
      color: #fff
      font-size: 14px
      font-weight: 400
  .col-right
    padding: 6rem 3rem
    -webkit-box-flex: 1
    -ms-flex: 1
    flex: 1
    position: relative
    color: #fff
    text-align: center
    .auth-user-testimonial
      position: absolute
      margin: 0 auto
      padding: 0 1.75rem
      bottom: 3rem
      left: 0
      right: 0
      h2
        font-weight: 700
      p
        font-size: 14px
        &.lead
          font-weight: 400
          font-size: 18px
  .footer
    bottom: 0
    padding: 19px 30px 20px
    position: absolute
    right: 0
    color: $mutedFontThemeColor
    width: 100%
    text-align: center
</style>
